export default "__VITE_ASSET__b331a7a1__"